import styled from 'styled-components';
import {Col} from 'react-bootstrap';

const BaseCol = styled(Col).attrs(() => ({
    className: 'align-self-center py-1',
}))``;

export default BaseCol;
